module.exports = __webpack_public_path__ + "img/college1.a7e7a4a4.png";